export default function Machines_A_3 (number = 1) {
  return {
    name: '风力涡轮机',
    icon: '/static/img/machines/a3.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_3.js